<template>
  <div class="links-wrap">
    <each-conference
      v-for="(conference, index) in conferences"
      :key="index"
      :conference="conference"
      @select-link="editLink"
      @edit-link="editLink"
      @confirm-delete="confirmActionDelete(deleteLink, $t('adminLinks.deleteLinkQuestion'), $event)"
      @add-link="addLink"
    ></each-conference>
  </div>
</template>

<script>
import api from "../../api";
import EachConference from "../../components/admin/links/EachConference.vue";
import AdminMixin from './adminMixin';
export default {
  mixins: [
    AdminMixin
  ],
  components: {
    EachConference
  },
  data() {
    return {
      conferences: [],
      stlIdToDelete: null
    };
  },
  mounted () {
    this.init();
  },
  methods: {
    async init () {
      this.startLoading();
        let tempConferences = await this.getConferences();
        let links = await this.getLinks();
        this.conferences = this.mapLinksToConferences(tempConferences, links);
      this.stopLoading();
    },
    async getConferences () {
      let apiObj = {
        api: api.getConferencesElements,
        onError: () => this.stopLoading()
      }
      const data = await this.apiCall(apiObj);
      if (data) return data.res;
    },
    async getLinks () {
      let apiObj = {
        api: api.getLinks,
        onError: () => this.stopLoading()
      }
      const data = await this.apiCall(apiObj);
      if (data) return data.links;
    },
    mapLinksToConferences (conferences, links) {
      let mappedConferences = [];
      for (let i = 0; i < conferences.length; i++) {
        let newConfObj = {links: []};
        for (let j = 0; j < conferences[i].length; j++) {
          if (conferences[i][j].loc_name) {
            newConfObj.loc_name = conferences[i][j].loc_name;
          }
  
          if (conferences[i][j].loc_id) {
            newConfObj.loc_id = conferences[i][j].loc_id;
          }
  
          if (newConfObj.loc_id && newConfObj.loc_name && links) {
            for (let k = 0; k < links.length; k++) {
              if (newConfObj.loc_id === links[k].loc_id) {
                newConfObj.links.push(links[k])
              }
            }
          }
          mappedConferences.push(newConfObj);
          break;
        }
      }
      return mappedConferences;
    },
    async addLink (confId) {
      let params = {
        link: "https://www.example-link.com",
        loc_id: confId
      }
      this.callApiShowMessageGetData(api.addLink, params, this.$t("adminLinks.newLinkAdded"));
    },
    confirmActionDelete (callback, message, data) {
      this.confirmAction(callback, message);
      this.stlIdToDelete = data.stl_id
    },
    async deleteLink () {
      let params = {
          stl_id: this.stlIdToDelete,
      }
      this.callApiShowMessageGetData(api.deleteLink, params, this.$t("adminLinks.linkDeleted"));
    },
    async editLink (newLinkObj) {
      // let params = {
      //   stl_id: this.linkObj.stl_id,
      //   link: this.linkObj.new_link,
      //   active: this.linkObj.stl_active ? 1 : 0,
      //   loc_id: this.linkObj.loc_id
      // }
      this.callApiShowMessageGetData(api.editLink, newLinkObj, this.$t("adminLinks.linkUpdated"));
    },
    async callApiShowMessageGetData (api, params, successMessage) {
      let apiObj = {
        api: api,
        params: params,
        onError: () => this.stopLoading()
      }
      this.startLoading();
        if (await this.apiCall(apiObj)) {
          this.showSuccessMessage(successMessage);
          await this.init();
        }
      this.stopLoading();
    }
  }
};
</script>

<style scoped lang="scss">
h1 {
  margin: 0;
  margin-bottom: 68px;
  font-size: 30px;
  line-height: 35px;
}
.links-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 3% 15% 3% 3%;
  background-color: #e5e5e5;
}
</style>